import { render, staticRenderFns } from "./BulkImportSuccessDialog.vue?vue&type=template&id=567fc3c2&scoped=true"
import script from "./BulkImportSuccessDialog.vue?vue&type=script&lang=js"
export * from "./BulkImportSuccessDialog.vue?vue&type=script&lang=js"
import style0 from "./BulkImportSuccessDialog.vue?vue&type=style&index=0&id=567fc3c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567fc3c2",
  null
  
)

export default component.exports